import axios from 'axios'

const baseURL = process.env.VUE_APP_CYLINDER_SERVICE + '/api/admin/specials'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async getSpecials ({ state, commit }) {
      return axios.get(baseURL)
    },
    async showSpecial ({ state, commit }, id) {
      return axios.get(baseURL + '/' + id)
    },
    async createSpecial ({ state, commit }, data) {
      return axios.post(baseURL, data)
    },
    async updateSpecial ({ state, commit }, data) {
      return axios.put(baseURL + '/' + data.id, data)
    },
    async deleteSpecial ({ state, commit }, id) {
      return axios.delete(baseURL + '/' + id)
    }
  }
}
